import React from 'react'
import styled from '@emotion/styled'
import { TDS_DEFAULT_COLORS, Text } from '@retailer-platform/shared-components/src/tds'
import { type AiButtonProps } from '../ai-button/AiButton'
import { useAiAgent } from '../../../utils/contexts/ai/AiAgentContext'

export interface AiButtonSendMessageProps extends AiButtonProps {
  message: string
  className?: string
  style?: React.CSSProperties
}

const TextContainer = styled.div({
  margin: '4px 0',
})

const ClickableText = styled.span({
  cursor: 'pointer',
  userSelect: 'none',
  display: 'inline-block',
  lineHeight: '16px',
  // Mint gradient light background
  background: 'linear-gradient(75deg, #E8FAF4 27.29%, #EAF5FA 90.23%)',
  // Font color
  color: TDS_DEFAULT_COLORS.colors.brandPrimaryRegular,
  fontWeight: '600', // semibold
  padding: '8px 12px',
  borderRadius: '6px',
  transition: 'all 0.2s ease',
  '&:hover': {
    background: 'linear-gradient(75deg, #DDF5E8 27.29%, #DDEEF5 90.23%)',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    background: 'linear-gradient(75deg, #D2F0DC 27.29%, #D0E7F0 90.23%)',
    transform: 'translateY(0)',
  },
})

export const AiButtonSendMessage: React.FC<AiButtonSendMessageProps> = ({
  message,
  className,
  style,
}) => {
  const { isAgentPowered, sendMessage, openChat } = useAiAgent()

  const handleClick = async () => {
    // Open chat first to ensure the conversation is visible
    openChat()
    // Send the fixed message
    await sendMessage(message)
  }

  return (
    <>
      {isAgentPowered && (
        <TextContainer>
          <ClickableText
            onClick={handleClick}
            className={className}
            style={style}
            data-testid="ai-button-send-message"
          >
            {message}
          </ClickableText>
        </TextContainer>
      )}
    </>
  )
}
